import { clsx } from "clsx";
import type { ReactNode } from "react";

const paddingClass = {
  md: "p-6",
} as const;

export type CardProps = {
  tone?: "default" | "tonal";
  padding?: keyof typeof paddingClass;
  className?: string;
  children?: ReactNode;
};

export function Card({ tone = "default", padding, className, children }: CardProps) {
  return (
    <div
      className={clsx(
        "rounded-[var(--radius-lg)] border border-border shadow-[var(--shadow-sm)] transition-shadow",
        "hover:shadow-[var(--shadow-md)]",
        tone === "tonal" ? "bg-surface" : "bg-surface-muted",
        padding && paddingClass[padding],
        className,
      )}
    >
      {children}
    </div>
  );
}
